import { render } from "./TreeBrowser.vue?vue&type=template&id=053bc736&scoped=true"
import script from "./TreeBrowser.js?vue&type=script&lang=js"
export * from "./TreeBrowser.js?vue&type=script&lang=js"

import "./TreeBrowser.vue?vue&type=style&index=0&id=053bc736&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053bc736"]])

export default __exports__